import React, { useContext } from 'react'
import CompactWorkItem from '@Components/WorkItemV2/CompactWorkItem'
import getCatalogPath from '@App/helpers/work-entities/utils/get-catalog-path'
import WorkItemData from '@Components/WorkItemV2/work-item-data'
import ShareDisplay from '@Components/WorkItemV2/ShareDisplay'
import { CardWithHeader } from '@Components/Tables/CardResults/card-with-header'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import CatalogCompactWorkItemHeader from '@Components/WorkItemV2/Catalog/CatalogCompactWorkItem/CatalogCompactWorkItemHeader'
import { observer } from 'mobx-react'

const CatalogCompactWorkItem: CardWithHeader<WorkItemData> = (props: WorkItemData) => {
    const { handleOnClick, yourShares, work } = props
    const { rightsholderStore, catalogSearchBulkActionStore } = useContext<RootStore>(StoresContext)

    const catalogPath = getCatalogPath(work.isComplete, rightsholderStore.currentRightsholderId, work.id || 0)

    const limitReached =
        catalogSearchBulkActionStore.idsSelectedForBulkAction.size > 100 &&
        !catalogSearchBulkActionStore.idsSelectedForBulkAction.has(work.id as number)

    const bulkActionDisabled = React.useMemo(() => {
        if (limitReached) {
            return { value: true, message: 'You can only select up to 100 works at a time.' }
        }
        return { value: false, message: '' }
    }, [limitReached])

    return (
        <CompactWorkItem
            work={work}
            catalogPath={catalogPath}
            handleOnClick={handleOnClick}
            isBulkActionDisabled={bulkActionDisabled.value}
            bulkActionDisabledMessage={bulkActionDisabled.message}
            isBulkActionStarted={catalogSearchBulkActionStore.activeBulkAction !== null}
            bulkActionToggle={() => catalogSearchBulkActionStore.toggleSelectionForBulkAction(work.id)}
            isBulkActionSelected={() => !!work.id && catalogSearchBulkActionStore.idsSelectedForBulkAction.has(work.id)}
        >
            <div className="container shares-group">
                {yourShares && <ShareDisplay share={yourShares} title="Your Shares" />}
                <ShareDisplay share={work.totalKnownShares} title="Total Known Shares" highlight />
            </div>
        </CompactWorkItem>
    )
}

CatalogCompactWorkItem.headerType = CatalogCompactWorkItemHeader

export default observer(CatalogCompactWorkItem)
